import React, { useEffect } from 'react';
import {
	Button,
	Card,
	CardActions,
	CardContent,
	Grid,
	Typography,
} from '@mui/material';
import { useState } from 'react';
import {
	handleConfirmModal,
	handleError,
	handleSuccess,
} from '../../helpers/utils';
import { Stack } from '@mui/system';
import { useNavigate } from 'react-router';
import { deleteArea, getAreas } from '../../actions/areas';
import { formatDateMX } from '../../helpers/hours';

export const AreasTable = () => {
	// Define state to know if it's loading or not
	const [areas, setAreas] = useState([]);

	// Navigation
	const navigate = useNavigate();

	// Get data
	const handleGetData = () =>
		getAreas().then(({ data }) => setAreas(data.results));

	useEffect(() => {
		handleGetData();
	}, []);

	// Handle delete user with modal confirmation
	const handleDelete = (id) => {
		handleConfirmModal(
			'Precaución',
			'¿Seguro que deseas borrar la área?',
			'warning',
			'Sí, borrar'
		)
			.then(({ isConfirmed }) => {
				if (isConfirmed) {
					deleteArea(id)
						.then(() => {
							handleGetData();
							handleSuccess('Área eliminada');
						})
						.catch((error) =>
							handleError(
								error,
								'Ocurrió un error al intentar eliminar la área'
							)
						);
				}
			})
			.catch((error) => handleError(error));
	};

	return (
		<div style={{ padding: '25px' }}>
			<Stack
				direction='row'
				alignItems='flex-end'
				justifyContent='space-between'
				style={{
					padding: '20px 20px 0 0',
					width: '100%',
				}}
			>
				<Typography variant='h4' gutterBottom>
					Áreas
				</Typography>
				<Button
					variant='contained'
					style={{ backgroundColor: '#143f6c', marginBottom: '15px' }}
					onClick={() => {
						const path = `/dashboard/areas/nueva-area`;
						navigate(path);
						localStorage.setItem('currentPathPilu', path);
					}}
				>
					Nueva área
				</Button>
			</Stack>
			<hr />
			<Grid container spacing={2} className='mt-2'>
				{areas.map((area) => (
					<Grid item xs={3} key={area.id}>
						<Card sx={{ minWidth: 200 }}>
							<CardContent>
								<Typography variant='h5' component='div'>
									{area.name}
								</Typography>
								<Typography
									sx={{ mb: 1.5 }}
									color='text.secondary'
								>
									Días autorizados: {area.days}
								</Typography>
								<Typography variant='body2'>
									Creado: {formatDateMX(area.created_at)}
									<br />
									Actualizado: {formatDateMX(area.updated_at)}
								</Typography>
							</CardContent>
							<CardActions>
								<Button
									size='small'
									onClick={() =>
										navigate(
											`/dashboard/areas/editar-area/${area.id}`
										)
									}
								>
									Editar
								</Button>
								<Button
									size='small'
									color='error'
									onClick={() => {
										handleDelete(area.id);
									}}
								>
									Eliminar
								</Button>
							</CardActions>
						</Card>
					</Grid>
				))}
			</Grid>
		</div>
	);
};
